import {withRouter} from 'react-router';

import DefaultForm from '@appComponents/DefaultForm';
import {getLink} from '@appComponents/Link';
import {convertToInt} from '@utils/helpers';

export class SdiOriginEntryPointForm extends DefaultForm {
    setLinkToIndexPage = () => (
        this.props.history.push(getLink('sdiOriginEntryPoints.index'))
    );

    componentDidMount() {
        this.setCreateSuccessCallback(() => {
            this.setLinkToIndexPage();
        });
        this.setUpdateSuccessCallback(() => {
            this.setLinkToIndexPage();
        });
        this.setDeleteSuccessCallback(() => {
            this.setLinkToIndexPage();
        });
    }

    prepareDataForSubmit = (data) => ({
        ...this.props.Model.dataMap[this.props.Model.entityDataMapKey],
        ...data,
        encoding_datacenter: data?.encoding_datacenter
            ? convertToInt(data.encoding_datacenter)
            : null,
    });

    renderErrors(errorData) {
        super.renderErrors(
            errorData,
            'SDI origin entry point',
            getLink('sdiOriginEntryPoints.index'),
            {size: 'tiny'}
        );
    }

    renderCancelButton = () => null;
}

export default withRouter(SdiOriginEntryPointForm);
